export function filterArrayByArray(arr1 = [], arr2 = [], key) {
  let result = [];
  if (key) {
    result = arr1.filter(item => {
      const innerFilter = arr2.filter(item2 => item[key] !== item2[key]);
      return innerFilter.length === arr2.length;
    });
  } else {
    result = arr1.filter(item => {
      const innerFilter = arr2.filter(item2 => item !== item2);
      return innerFilter.length === arr2.length;
    });
  }
  return result;
}
